﻿import { useEffect } from "react";
import { useKnopClient } from "@opstel/contexts/knopClient/useKnopClient";
import { instances } from "@opstel/query/queryKeys/instanceKeys";
import { useSelectedTimeStore } from "@shared/common/contexts/SelectedTime/useSelectedTimeStore.ts";
import { useCurrentInstanceId } from "@shared/common/contexts/instanceMetadata/useInstanceId";
import { useQuery } from "@tanstack/react-query";
import { usePersoneelsinstellingenStore } from "@personeel/stores/PersoneelsinstellingenStore.ts";
import { useFetchPersoneelsinstellingen } from "./useFetchData.ts";
/**
 * Hook die automatisch personeelsinstellingen ophaalt en de PersoneelsinstellingenStore update
 * op basis van het scenario interval en de scenario-locatie (knooppuntnaam).
 */
export function usePersoneelsinstellingen() {
  const { knopClient } = useKnopClient();
  const { instanceId } = useCurrentInstanceId();
  const { scenarioInterval } = useSelectedTimeStore();
  const setPersoneelsinstellingen = usePersoneelsinstellingenStore(
    (state) => state.setPersoneelsinstellingen,
  );

  const { data: scenario } = useQuery({
    queryKey: instances.current(instanceId).scenario,
    queryFn: () => knopClient.getScenario(instanceId),
    enabled: !!instanceId,
  });

  // Format de datumtijd in ISO format voor de API call
  const vanafTijd = scenarioInterval?.start?.toISO() ?? "";
  const totEnMetTijd = scenarioInterval?.end?.toISO() ?? "";
  const knooppuntNaam = scenario?.location ?? "";

  // Haal personeelsinstellingen op
  const { data: settingsArray, isError } = useFetchPersoneelsinstellingen(
    vanafTijd,
    totEnMetTijd,
    knooppuntNaam,
  );
  // Update de store met de opgehaalde instellingen
  useEffect(() => {
    if (!settingsArray || settingsArray.length === 0) {
      console.warn("Geen personeelsinstellingen gevonden");
      return;
    }
    const setting = settingsArray[0];
    if (
      setting.voortijd !== undefined &&
      setting.voortijd !== null &&
      setting.natijd !== undefined &&
      setting.natijd !== null
    ) {
      setPersoneelsinstellingen({
        voortijd: Number(setting.voortijd) / 60,
        natijd: Number(setting.natijd) / 60,
      });
    } else {
      console.warn("Personeelsinstellingen: voortijd of natijd ontbreekt");
    }
  }, [settingsArray, setPersoneelsinstellingen]);
  return { isError };
}
